import React from 'react';
import {Route,Redirect} from 'react-router-dom';
import {useSelector} from 'react-redux';
import Loader from '../loader/Loader';


const PrivateRoute = ({ component: Component,...props }) =>{
  const isUserLogged = useSelector(state=>state.user.isUserLogged);
  const loading_user = useSelector(state=>state.user.loading_user);



  return(
    <Route
        {...props}
        render={props =>
          isUserLogged  ? (
            <Component {...props} />
          ) : loading_user ? (
            <Loader />
          ) : (
            <Redirect
              to={{
                pathname: '/login',
              }}
            />
          )
        }
      />
  )
}

export default PrivateRoute
